import { Routes } from '@angular/router';

import { authGuard } from '../../core/guards/auth.guard';
import { loginGuard } from '../../core/guards/login.guard';

export const routes: Routes = [
  {
    canActivate: [authGuard],
    loadComponent: () =>
      import('../create-project/create-project.component').then(
        (m) => m.CreateProjectComponent,
      ),
    path: 'create',
  },
  {
    canActivate: [loginGuard],
    loadComponent: () =>
      import('../profile/login/login.component').then((m) => m.LoginComponent),
    path: 'login',
  },
  {
    canActivate: [authGuard],
    loadComponent: () =>
      import('../project-list/project-list.component').then(
        (m) => m.ProjectListComponent,
      ),
    path: 'list',
  },
  {
    loadComponent: () =>
      import('../result-map/result-map.component').then(
        (m) => m.ResultMapComponent,
      ),
    path: 'results',
  },
  { path: '**', pathMatch: 'full', redirectTo: 'create' },
];
